import { useState } from 'react';
import { useNavigate } from 'react-router';
import { DropdownMenu, DropdownMenuContent } from '@/components/ui/dropdown-menu';
import { DropdownMenuItem, DropdownMenuLabel, DropdownMenuSeparator } from '@/components/ui/dropdown-menu';
import { DropdownMenuTrigger } from '@/components/ui/dropdown-menu';
import { MoreHorizontal } from 'lucide-react';
import { isPreStart } from 'helpers/experiment-status';
import { ConfirmDialogs } from './ConfirmDialogs';

type DialogActionTypes = 'delete' | 'archive' | 'duplicate';
type RowActionsProps = { experiment: any };

export const RowActions = ({ experiment }: RowActionsProps) => {
  const { id } = experiment;
  const [dialogAction, setDialogAction] = useState<DialogActionTypes | null>(null);
  const navigate = useNavigate();

  const canDelete = isPreStart(experiment.status);
  const canArchive = experiment.status === 'Ended';

  return (
    <DropdownMenu>
      <DropdownMenuTrigger className="text-dim hover:bg-hover hover:text-foreground flex size-7 shrink-0 items-center justify-center rounded-lg transition-colors duration-150">
        <span className="sr-only">Open actions</span>
        <MoreHorizontal className="size-4" strokeWidth={1.5} />
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        <DropdownMenuLabel className="micro-label">Actions</DropdownMenuLabel>
        <DropdownMenuItem className="text-body" onClick={() => navigate(`/experiments/${id}`)}>
          View
        </DropdownMenuItem>
        <DropdownMenuItem className="text-body" onClick={() => setDialogAction('duplicate')}>
          Duplicate
        </DropdownMenuItem>
        <DropdownMenuSeparator />
        {/*
          The rule goes in the label, not a tooltip: a disabled Radix item takes no
          hover, so "why can't I archive this?" was unanswerable from the menu. Same
          shape GoalsConfig already uses for its disabled checkbox.
        */}
        <DropdownMenuItem className="text-body" onClick={() => setDialogAction('archive')} disabled={!canArchive}>
          Archive{!canArchive && <span className="text-dim ml-1">— only once ended</span>}
        </DropdownMenuItem>
        <DropdownMenuItem className="text-body" onClick={() => setDialogAction('delete')} disabled={!canDelete}>
          Delete{!canDelete && <span className="text-dim ml-1">— drafts only</span>}
        </DropdownMenuItem>
      </DropdownMenuContent>
      {dialogAction && (
        <ConfirmDialogs experiment={experiment} dialogAction={dialogAction} setDialogAction={setDialogAction} />
      )}
    </DropdownMenu>
  );
};
